import React from "react";
import { getDefaultName } from "../../../../utils";
import ParticipantsCount from "../../../../components/ParticipantsCount";

export default function WidgetDashboardStats({
  usersCount,
  audienceCount,
  course,
  onlineUsersCount,
}) {
  return (
    <div className="row">
      <div className="col-lg-3 col-xs-6">
        <div className="small-box bg-yellow-dashboard">
          <div className="inner">
            <h3>{usersCount}</h3>
            <p>Talent Registrations</p>
          </div>
          <div className="icon">
            <i className="ion ion-person-add" />
          </div>
          <a href="users" className="small-box-footer">
            More info <i className="fa fa-arrow-circle-right" />
          </a>
        </div>
      </div>

      <div className="col-lg-2 col-xs-6">
        <div className="small-box bg-red ">
          <div className="inner">
            <h3>{audienceCount}</h3>
            <p>Public Votes</p>
          </div>
          <div className="icon">
            <i className="ion ion-stats-bars" />
          </div>
          <a href="audience" className="small-box-footer">
            More info <i className="fa fa-arrow-circle-right" />
          </a>
        </div>
      </div>

      <div className="col-lg-3 col-xs-6">
        <div className="small-box bg-green">
          <div className="inner">
            <h3 title="talents participated in a contest">
              {course && <ParticipantsCount course_id={course.id} />}
            </h3>
            <p>{course && getDefaultName(course.names)}</p>
          </div>
          <div className="icon">
            <i className="fa fa-flag-o" />
          </div>
          <a href={course && `coursedetails/${course.id}`} className="small-box-footer">
            More info <i className="fa fa-arrow-circle-right" />
          </a>
        </div>
      </div>

      <div className="col-lg-2 col-xs-6">
        <div className="small-box bg-aqua ">
          <div className="inner">
            <h3>46</h3>
            <p>Cities</p>
          </div>
          <div className="icon">
            <i className="ion ion-stats-bars" />
          </div>
          <a href="conteststats" className="small-box-footer">
            More info <i className="fa fa-arrow-circle-right" />
          </a>
        </div>
      </div>

      <div className="col-lg-2 col-xs-6">
        <div className="small-box bg-navy">
          <div className="inner">
            <h3>{onlineUsersCount ? onlineUsersCount + 1 : 1}</h3>
            <p>Online Users</p>
          </div>
          <div className="icon">
            <i className="ion ion-pie-graph" />
          </div>
          <a href="online" className="small-box-footer">
            More info <i className="fa fa-arrow-circle-right" />
          </a>
        </div>
      </div>
    </div>
  );
}
